module.exports = __webpack_public_path__ + "static/william-4400a5d02f3b8e7b420bb055d895a2bd.png";